import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Sim } from "../../../model/sim";

class DataForSimCreation {
  sim: Sim = new Sim();
  creatingFromBox?: boolean;
}

@Component({
  selector: 'aw-create-sim',
  templateUrl: './create-sim-dialog.component.html',
  styleUrls: ['./create-sim-dialog.component.scss']
})
export class CreateSimDialogComponent implements OnInit {

  creatingFromBox = false;
  returnThisInDialogClose?: boolean | Sim;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DataForSimCreation,
    public dialogRef: MatDialogRef<CreateSimDialogComponent>,
  ) {


  }

  ngOnInit(): void {
    if (this.data.creatingFromBox)
      this.creatingFromBox = this.data.creatingFromBox;
    else
      this.returnThisInDialogClose = true;

  }

  returnSim(event: Sim): void {
    this.returnThisInDialogClose = event;
  }


}


